import troubles from "./bs_en_troubles";

export default [
  [
    {
      q: "¿Por qué el Bluetooth no puede encontrar mi scooter?",
      a:
        "1. Compruebe si el scooter está encendido y si está en modo P. <br/>\
      2. Compruebe si la función Bluetooth de su teléfono móvil está activada o intente reiniciar la función Bluetooth del teléfono. <br/>\
      (Debido al error del sistema de Android 10, los usuarios de teléfonos con Android 10 deben activar la función de localización) <br/>\
      3. Compruebe si el scooter está en un estado de vinculación pendiente. <br/>\
      Para garantizar la seguridad de su scooter, cuando el scooter entra en el estado de vinculación pendiente, si el usuario no manipula, empuja ni conduce el scooter dentro de los 2 minutos, el scooter saldrá automáticamente del estado de vinculación pendiente, o el scooter no puede ser encontrado por el teléfono por Bluetooth. Puede volver a encender el scooter y llevar a cabo la activación a través de la búsqueda en la aplicación dentro de un período determinado."
    },
    {
      q:
        "Cuando se conecta el scooter encontrado, ¿por qué la aplicación dice que la conexión falló?",
      a:
        "1.Comprueba si el vehículo está en estado vinculante.<br/>\
      Para garantizar la seguridad de su vehículo, después de que el vehículo ingrese al estado vinculante, si no hay operación, empuje o conducción dentro de los 5 minutos, el vehículo saldrá automáticamente del estado vinculante, por lo que el vehículo no podrá conectarse.<br/>\
      Puede completar la operación de activación reiniciando el vehículo y buscando a través de la aplicación dentro de un tiempo específico.<br/>\
      2. Puede ser que la señal de Bluetooth de su teléfono móvil sea inestable, lo que dificulta la conexión. Puede probar a encender y apagar la función bluetooth del teléfono móvil e intentar conectarse de nuevo al vehículo."
    },
    {
      q:
        "¿Cómo identifico el scooter objetivo cuando se encuentran varios scooteres?",
      a:
        "Puede determinar qué vehículo desea vincular comparando la información del número de bastidor. El número de cuadro generalmente se encuentra cerca del puerto de carga en el asiento de su vehículo, o donde está impreso el VIN, como se muestra a continuación:\
      <div style='text-align:center;padding-top:24px;'><img src='/static/img/q3.png' width='180px' alt=''></div>"
    },
    {
      q: '¿Qué hacer si la aplicación dice "Activando la red del scooter..."?',
      a:
        '1.Compruebe si la conexión de red de su scooter es normal. <br/>\
      Puede comprobar el estado de la red en la pantalla del scooter. Si encuentra que la conexión de la red del scooter es deficiente, se recomienda que mueva el scooter a un entorno abierto al aire libre o a un entorno con una buena red. <br/>\
      2.Compruebe si la conexión de red de su teléfono móvil es normal. <br/>\
      Es posible que el estado de activación no se sincronice correctamente debido a una red telefónica anormal o inestable. <br/>\
      3.Compruebe si el "permiso de notificación" de su aplicación está activado. Puede ir a la Configuración→Notificaciones→Aplicación →Abrir el permiso de notificación en el teléfono; (el proceso de operación puede diferir en diferentes sistemas operativos) <br/>\
      4.Puede intentar reiniciar la aplicación o cerrar sesión en la cuenta de inicio de sesión de la aplicación e iniciar sesión nuevamente para resolver el problema.'
    },

    {
      q:
        "¿Se finaliza el proceso de conexión Bluetooth después de la activación y vinculación exitosas?",
      a:
        "Después de una activación y vinculación exitosas, solo se realizado la conexión del módulo BLE (Bluetooth de Baja Energía) entre el teléfono móvil y el scooter para la comunicación básica entre ambos. <br/>\
      Si necesita usar funciones relacionadas con Bluetooth, como reproducir la música o llamadas telefónicas, vaya a la Configuración del teléfono y conecte el scooter a su teléfono por Bluetooth."
    },

    {
      q: "¿Cómo desvinculo el scooter?",
      a:
        "Inicie sesión en la aplicación, seleccione en la barra lateral el vehículo que desea desvincular, haga clic en Eliminar vehículo, verifique Eliminar acuerdo y haga clic en Eliminar para desvincularse correctamente."
    },

    {
      q:
        "¿Por qué el scooter no puede entrar en el estado de activación pendiente después de desvincularse de una cuenta?",
      a:
        "Después de la desvinculación, si el scooter no puede volver a entrar en el estado de activación pendiente, puede deberse a la mala conexión de red del scooter actual: <br/>\
      1.Estacione su scooter en un área abierta con una buena señal, luego vuelva a encender para comprobar el estado; <br/>\
      2.Compruebe si el servicio inteligente del scooter haya caducado. En caso afirmativo, renueve el servicio, luego vuelva a encender el scooter para comprobar el estado.<br/>\
      * Algunos modelos pueden ingresar a la función de configuración del vehículo, encontrar el modo 'Modo para vincular' y configurar activamente el estado del vehículo para vincularlo."
    }
  ],
  [
    {
      q: "¿Cómo actualizar/desvincular mi número de teléfono?",
      a:
        "Para garantizar la seguridad de su cuenta, debe vincular un número de teléfono móvil después de activar el scooter. Por lo tanto, la cuenta que se utilizó para activar el scooter no se puede desvincular directamente. Se admite la actualización del número de teléfono. <br/>\
      Si necesita actualizar su número de teléfono, vaya a la página Configuración, ingrese al Centro de Seguridad de la Cuenta, administre la vinculación de la cuenta y haga clic en el número de teléfono para cambiarlo."
    },

    {
      q: "¿Puedo usar la cuenta en varios teléfonos?",
      a:
        "El inicio de sesión de la cuenta no está restringido a dispositivos móviles. Sin embargo, para proteger la seguridad de la cuenta y del vehículo, no se puede usar la misma cuenta en varios dispositivos móviles al mismo tiempo. De lo contrario, la cuenta se cerrará automáticamente desde otros dispositivos."
    },

    {
      q: "¿Cómo eliminar mi cuenta?",
      a:
        "La aplicación admite la eliminación de cuentas. Antes de hacerlo, asegúrese de que no haya scooteres vinculados o servicios pendientes o no pagados en esta cuenta. <br/>\
      Puede hacer clic en Configuración → Seguridad de la Cuenta → Eliminar Cuenta para eliminar su cuenta. Esta eliminación de la cuenta es irreversible, por eso, opere con cuidado. Después de eliminar, no podrá iniciar sesión ni acceder a ningún dato relacionado con la cuenta de Blueshark."
    },

    {
      q: "¿Cómo gestionar los permisos de datos de mi scooter?",
      a:
        "Damos gran importancia a la protección de su privacidad e información personal.<br/>\
        Puede usar la aplicación para realizar, entre otros, ver las condiciones del vehículo, posicionar los vehículos, ubicar su ubicación, registro dinámico del vehículo, vehículos de control remoto, configuración de vehículos y otras funciones.<br/>\
      De acuerdo con el principio de 'minimización', obtendremos directa o indirectamente la ubicación de su vehículo y la información de la ruta de conducción, y realizaremos el procesamiento de encriptación.<br/>\
      Puede acceder a la página de gestión de vehículos y seleccionar la función Datos y permisos del vehículo para gestionar el permiso. Después de desactivar una función, algunas funciones pueden dejar de estar disponibles."
    }
  ],
  [
    {
      q: "¿Qué debo preparar antes de conducir?",
      a:
        "Para garantizar su seguridad, realice los siguientes preparativos antes de conducir: <br/>\
      1. Compruebe si el scooter está normalmente encendido y si la iluminación y otras condiciones son normales; <br/>\
      2. Compruebe si el freno delantero y el trasero pueden funcionar normalmente; <br/>\
      3. Compruebe si la presión de los neumáticos es normal; <br/>\
      4. Compruebe si los manillares, las ruedas delanteras y traseras están fijados, y si la cerradura de cabeza está desbloqueada; <br/>\
      5. Asegúrese de que la batería restante sea suficiente; <br/>\
      6. Compruebe si hay alertas de fallas; <br/>\
      7. Use un casco y otros equipos de protección."
    },

    {
      q: "¿Cómo se enciende el scooter?",
      a:
        "Puede arrancar el vehículo de varias maneras:<br/>\
        1. Tecla de control remoto: (1) Haga clic en el botón de desbloqueo en el control remoto; (2) Lleve consigo la llave del control remoto. Cuando se acerque al vehículo, el botón de encendido (como el botón de encendido o el botón de listo) parpadeará regularmente. Manténgalo presionado para arrancar el vehículo;<br/>\
        2. Aplicación: (1) Abra la aplicación y haga clic en 'Iniciar' para iniciar el vehículo; (2)) El vehículo está vinculado al teléfono móvil. Cuando el vehículo está cerca del vehículo, el botón de encendido (como el botón de encendido o el botón de listo) parpadeará regularmente. Manténgalo presionado para arrancar el vehículo;<br/>\
        3. Desbloqueo por huella dactilar: algunos modelos cuentan con áreas de identificación por huella dactilar, por lo que los usuarios pueden arrancar el vehículo con sus huellas dactilares sin necesidad de llevar llaves o teléfonos móviles."
    },
    {
      q:
        "¿Por qué no hay salida de potencia al girar el manillar, aunque el scooter esté encendido?",
      a:
        'Para proteger su seguridad al conducir y evitar riesgos como salir corriendo, el scooter utiliza sensores para garantizar un encendido seguro. Antes de conducir, es necesario levantar el caballete lateral o el central y luego sentarse en el scooter. <br/>\
      Pulse el botón " READY " en el manillar derecho, y el indicador " READY " se iluminará y el scooter estará listo para conducir. Ahora, puede girar el manillar para comenzar a conducir. <br/>\
      Die oben genannten Funktionen sind nur für einige Modelle verfügbar, die über das Fahrzeugzentrum der mobilen APP ein- und ausgeschaltet werden können.'
    },

    {
      q: "¿Qué debo hacer después al terminar la conducción?",
      a:
        'Cuando llegue a su destino, presione el botón "READY" para cancelar el modo READY y baje la abrazadera lateral o la abrazadera central. <br/>\
        Puede bloquear su vehículo de las siguientes maneras:<br/>\
        1. Control remoto: haga clic en el botón de bloqueo en el control remoto;<br/>\
        2. Teléfono móvil: abra la aplicación móvil y haga clic en "Guardia" para bloquear el vehículo;<br/>\
        3. Vehículo: De acuerdo con las instrucciones del manual del vehículo, fortalezca a través de los botones físicos en el manillar del vehículo.<br/>\
        Después de bloquear el vehículo, gire el grifo hacia la izquierda y verifique si el bloqueo del grifo está bloqueado.'
    }
  ],
  [
    {
      q: "¿Qué es la función de detección electrónica del caballete lateral?",
      a:
        "Para garantizar su seguridad, la función de detección electrónica del caballete lateral se utiliza para detectar el estado del caballete lateral, es decir, el levantamiento o la bajada. Cuando esté listo para conducir, esta función le recordará que levante el caballete lateral antes de comenzar a conducir. <br/>\
      Esta función se puede activar o desactivar a través del sistema operativo del vehículo o la configuración de la aplicación. Se recomienda que los usuarios novatos mantengan esta función activada."
    },

    {
      q: "¿Qué es la función de detección de presión del asiento?",
      a:
        "Para garantizar su seguridad, la función de detección de presión del asiento (la función de Encendido Fácil para los modelos R1) se utiliza para detectar si una persona ya está sentada en el scooter o no. Cuando esté listo para conducir, esta función le recordará que debe sentarse firmemente antes de la conducción. <br/>\
      Esta función se puede activar o desactivar a través del sistema operativo del vehículo o la configuración de la aplicación. Se recomienda que los usuarios novatos mantengan esta función activada."
    },
    {
      q: "¿Qué es la función de dirección asistida?",
      a:
        "Para garantizar su seguridad, la función de dirección asistida activará la cámara trasera durante el giro para mostrarle el estado de la carretera por detrás, compensando así el punto ciego. <br/>\
        (Esta función solo es compatible con algunos modelos)"
    },

    {
      q: "¿Qué es la función de asistencia de marcha atrás?",
      a:
        "Para garantizar su seguridad, la función de asistencia de marcha atrás activará la cámara trasera y el radar ultrasónico trasero durante la marcha atrás para mostrarle los obstáculos detrás del scooter y la distancia de los mismos, compensando así el punto ciego. <br/>\
        (Esta función solo es compatible con algunos modelos)"
    }
  ],
  [
    {
      q: "¿Cómo conectar el teléfono móvil?",
      a:
        "1.Después de estacionar el scooter de forma segura, abra el Menú Inteligente y seleccione la Configuración de Bluetooth; <br/>\
      2.Seleccione 'Teléfono móvil' y active el Bluetooth, y haga clic para conectar el teléfono móvil; <br/>\
      3.Diríjase a la página Bluetooth del teléfono y asegúrese de que se pueda encontrar el teléfono móvil; <br/>\
      4.En el scooter, elija su teléfono móvil y conéctelo; <br/>\
      5.El scooter puede recordar los dispositivos móviles conectados anteriormente, por lo que una vez que los dispositivos conectados estén cerca, pueden conectarse al scooter automáticamente. (Los dispositivos iOS conectados anteriormente solo se pueden conectar nuevamente cuando el Bluetooth del teléfono está activado, mientras que los dispositivos Android no se ven afectados por esta regla). <br/>\
      6.Para desconectar un dispositivo, simplemente elija el dispositivo correspondiente en el scooter; <br/>\
      7.Si el scooter no puede detectar su teléfono móvil, asegúrese de que la función Bluetooth de su teléfono móvil esté activada y de que haya abierto la página Bluetooth. Si el scooter aún no puede encontrarlo, desactive el Bluetooth y luego vuelva a activarlo."
    },

    // {
    //   q: "如何连接蓝牙耳机或蓝牙头盔？",
    //   a:
    //     "（目前该功能仅支持R1 车型）<br/>\
    //   1.在车辆驻车状态下，打开智能菜单选择蓝牙设置功能；<br/>\
    //   2.选择“耳机/头盔”并开启蓝牙功能，选择您的设备名称并连接；<br/>\
    //   3.打开手机，并打开蓝牙页面，以保证手机设备可以被搜索到；<br/>\
    //   4.若要断开链接，选择断开相应的设备即可。"
    // },
    {
      q: "¿Cómo activar la función de reproducir la música por Bluetooth?",
      a:
        "1.Asegúrese de que su teléfono móvil y sus auriculares/casco estén conectados al scooter. De lo contrario, la música se reproducirá a través del altavoz del scooter; <br/>\
      2.Cuando reproduce la música con el teléfono móvil, puede reproducir la música con el scooter, sin importar si está estacionado o en la carretera.<br/>\
      3.Puede usar el botón de reproducción/pausa del scooter para reproducir y pausar la música, pulse el botón OK para reproducir la siguiente canción y haga clic en los botones Más y Menos para subir o bajar el volumen."
    }

    // {
    //   q: "如何使用蓝牙电话功能？",
    //   a:
    //     "（目前该功能仅支持R1 车型）<br/>\
    //   1.在车辆驻车状态下，打开智能菜单选择蓝牙电话功能；<br/>\
    //   2.请确保车辆已经连接了您的手机和耳机/头盔，需要您耳机/头盔的麦克风进行通话。<br/>\
    //   3.选择“同步通讯录”，将手机的最近联系人和通话记录同步到车机上；<br/>\
    //   4.我们为您提供了“最近联系人”“所有通话”“未接来电”三个选项，你可以在驻车状态下进行外呼。<br/>\
    //   最近联系人：车辆读取手机通讯录中最近有过通话的10个人；<br/>\
    //   所有通话：车辆显示最近3天的通话记录（最多20条）；<br/>\
    //   未接来电：车辆在所有通话中筛选出所有未接来电（最多20条）；<br/>\
    //   5.若有人向你呼入通话，你可通过按车机上的OK键接通，或使用“返回”键挂断。"
    // }
  ],
  [
    {
      q: "Localización del scooter",
      a:
        "El scooter obtiene la ubicación a través de la señal GPS. Cuando un scooter esté en el interior o en un área cerrada, como un sótano, la precisión de la localización del scooter se verá afectada. Mueva el scooter a un entorno abierto y su función de GPS se volverá normal. <br/>\
      La ruta se forma conectando los puntos de localización informados por el scooter dentro de un período de tiempo específico. Debido a la desviación de la localización y la interrupción de la señal, puede haber una localización incorrecta o incluso la pérdida de puntos de localización, lo que resulta en rutas anormales o inexactas. <br/>\
      Si no puede localizar el scooter durante mucho tiempo o si la mayoría de las rutas son incorrectas, compruebe si el Servicio Inteligente del scooter ha caducado. De lo contrario, puede comunicarse con el centro de servicio para comprobar la red y el GPS del scooter."
    },

    {
      q: "Notificaciones push",
      a:
        "Puede solucionar el problema de acuerdo con las siguientes instrucciones: <br/>\
      1.Vaya al Centro de Mensajes en la esquina superior derecha de la página de inicio de la aplicación para confirmar si puede recibir mensajes push como 'vibración del scooter'; <br/>\
      2.Administre la configuración de notificaciones de su teléfono. Vaya a la página Configuración, seleccione Notificaciones, seleccione la aplicación de y asegúrese de que las notificaciones estén permitidas. <br/>\
      3.Seleccione el scooter en la aplicación de, seleccione el Modo de Antirrobo del scooter, y compruebe si se permiten las notificaciones automáticas."
    },

    {
      q: "¿Qué es el Modo de Antirrobo del scooter?",
      a:
        'Para garantizar la seguridad de su scooter, se envían notificaciones para alertarle sobre eventos anormales, como vibraciones del scooter, movimiento de las ruedas, desconexión de la batería, sobredescarga de la batería, etc. <br/>\
      Puede seleccionar "En guardia" o "No Molestar" de acuerdo con el riesgo de estacionamiento del scooter y personalizar su configuración de seguridad. <br/>\
      Si el scooter se mueve, puede comprobar la ubicación actual del scooter para asegurarse de que esté seguro.'
    },
    {
      q: "Autonomía estimada imprecisa",
      a:
        "La autonomía estimada del scooter se calcula en función de los hábitos de conducción del usuario y el historial de consumo de energía correspondiente. La precisión de la autonomía estimada se ve afectada por varios factores, como las condiciones de carga, las condiciones de la carretera y la temperatura ambiente. Generalmente, las desviaciones inferiores al 20% son normales. <br/>\
        Si la desviación es obviamente demasiado grande o demasiado pequeña, generalmente no se debe a la batería, sino a la estabilidad de los datos o a los errores de datos. Si siguen existiendo grandes desviaciones después de conducir varias veces, comuníquese con el servicio posventa para una mejor solución de problemas."
    },

    {
      q: "¿Qué debo hacer si el scooter no responde al control remoto?",
      a:
        "Compruebe si la red de su teléfono móvil es normal y, en la esquina superior derecha de la página de inicio de la aplicación, compruebe si la conexión de red y Bluetooth es normal. Si Internet o Bluetooth están conectados normalmente, se puede emitir el comando del control remoto."
    }
  ],
  [
    {
      q: "¿Cuál es el propósito de las actualizaciones del scooter?",
      a:
        "El objetivo principal de las actualizaciones OTA es mejorar la experiencia del usuario y optimizar las funciones del scooter. Cada vez que haya una actualización OTA disponible, se avisará de los detalles de la actualización. Consulte la página al actualizar para obtener más detalles."
    },
    {
      q: "¿Cuáles son los requisitos para las actualizaciones del scooter?",
      a:
        "1.Asegúrese de que el scooter esté encendido y en estado de estacionamiento. Y asegúrese de que la batería restante del scooter sea superior al 20%. No retire la batería durante la actualización. <br/>\
      2.Asegúrese de que el Bluetooth y la red móvil de su teléfono estén activados. Acérquese al scooter y mantenga el teléfono móvil y el scooter conectados."
    },

    {
      q: "¿A qué debo prestar atención durante el proceso de actualización?",
      a:
        "1.No conduzca el scooter durante la actualización, asegúrese de que el scooter esté encendido y no en el modo de conducción; <br/>\
      2.Durante la actualización, no se aleje del scooter y mantenga el scooter y el teléfono móvil siempre conectados; <br/>\
      3.Al iniciar la actualización, no retire la batería del scooter; <br/>\
      4.Después del inicio de la actualización, no apague la pantalla o la aplicación, y mantenga la red celular del teléfono móvil y el Bluetooth encendidos."
    },

    {
      q: "¿Por qué siempre se interrumpe la transferencia de archivos?",
      a:
        "En el proceso de actualización del vehículo, el teléfono móvil se conecta al vehículo a través de la red WiFi para la transmisión de archivos. Durante la transferencia de archivos, el teléfono móvil no está en estado de red. Una vez completada la transferencia de archivos, se restablece la red de telefonía móvil.<br/>\
      Algunos usuarios de teléfonos móviles IOS recordarán al usuario que el estado actual de la red no es bueno, ya sea para desconectar o cambiar la red, elija continuar usando la red actual;<br/>\
      Para algunos usuarios de teléfonos móviles con Android, deshabilite la función de selección de WLAN reciente porque desconecta o cambia automáticamente la red. Puede habilitarlo después de que se complete la transferencia de archivos."
    },

    {
      q:
        "La actualización ha terminado, pero no sé si se ha realizado correctamente.",
      a:
        "No se aleje del vehículo durante la actualización y mantenga el Bluetooth conectado.<br/>\
        Durante el proceso de actualización del vehículo, el progreso y el estado de la actualización se presentarán respectivamente en el sistema del motor del vehículo y en la terminal de la aplicación.<br/>\
      Si la conexión se desconecta debido a circunstancias especiales, puede intentar volver a conectar el vehículo. O actualice la página de actualización del sistema para ver la versión actual del vehículo. Si se muestra la última versión, la actualización se realizó correctamente. Si algunos componentes no son la última versión, actualícelos nuevamente."
    }
  ],
  [
    {
      q: "¿Cómo cargar la batería?",
      a:
        "El vehículo admite una variedad de modos de carga y recarga:<br/>\
      1. Cargador:<br/>\
      Coloque la base de carga sobre una superficie plana y asegúrese de que la temperatura ambiente no sea ni demasiado alta ni demasiado baja y que el ambiente no esté húmedo. Conecte el cargador de carga directa a la fuente de alimentación, luego conecte la base de carga al cargador de carga directa y coloque la batería en la base correctamente para comenzar a cargar. Cuando necesite cargar dos baterías al mismo tiempo, conecte el divisor al cargador y las dos bases de carga respectivamente.<br/>\
      La base de carga debe usarse junto con un cargador de carga directa.<br/>\
      2.Carga directa:<br/>\
      Puede cargar el vehículo mientras las baterías están adentro. Enchufe la fuente de alimentación en el conector de carga y podrá saber si la batería está llena a través de la pantalla.<br/>\
      3.BSS:<br/>\
      Parte del área cubre la red de carga del BSS, que se puede cambiar a través del BSS abriendo el servicio de intercambio."
    },

    {
      q: "¿Cuáles son las precauciones durante el uso de la batería?",
      a:
        "1.Entorno operativo de la batería: <br/>\
        -10~45℃; <br/>\
      Evite ser empapada por líquidos; <br/>\
          Evite que entren objetos metálicos extraños en el compartimiento de la batería; <br/>\
          Evite colocar la batería cerca del fuego abierto, o materiales inflamables y explosivos. <br/>\
      2.Degradación de la capacidad de la batería: <br/>\
      En condiciones de baja temperatura, la capacidad utilizable de la batería se degradará en diversos grados. El valor de referencia es lo siguiente: <br/>\
      Cuando la temperatura es de -10 °C, la capacidad utilizable de la batería es de aproximadamente el 70%;<br/>\
      0 ℃, alrededor del 85%; <br/>\
      25 ℃, alrededor del 100%; <br/>\
      3.Precauciones de seguridad de la batería: <br/>\
      Si la batería se calienta, se deforma o produce olor, deje de usarla inmediatamente y manténgase alejado de la batería. Póngase en contacto con el centro de servicio postventa para su inspección y reparación. Por favor, no lo desmonte usted mismo. Si la batería se desmonta sin autorización, pueden ocurrir accidentes como incendios y explosiones, y la garantía de la batería se vuelve inválida."
    },

    {
      q: "¿Cómo prolongar la vida útil de la batería?",
      a:
        "La vida útil de la batería depende principalmente del número de ciclos de carga y del entorno de almacenamiento. Un ciclo de carga se refiere al proceso de descarga completa de una batería cargada al 100% y su posterior carga completa. Los buenos hábitos de uso como el almacenamiento al 50% del nivel de batería en un ambiente seco con una temperatura entre 0 °C y 25 °C y evitar la descarga excesiva pueden ayudar a prolongar la vida útil de la batería."
    }
  ],
  [
    {
      q: "Instrucciones de mantenimiento del scooter",
      a:
        "1.Implementación de mantenimiento regular<br/>\
        El mantenimiento regular puede extender efectivamente la vida útil de los vehículos. El usuario puede mantener el vehículo regularmente de acuerdo con los recordatorios del sistema del vehículo o la aplicación.<br/>\
        Sin un mantenimiento regular, el scooter puede tener riesgos de seguridad, lo que lleva a mal funcionamiento o accidentes. Durante el proceso de mantenimiento, si encuentra alguna anomalía en el scooter, llévelo a una tienda designada o al centro de servicio designado para su inspección y reparación.<br/>\
      2.Métodos de mantenimiento: En el manual se describen algunos ítems principales de inspección. Para una inspección más exhaustiva, diríjase a la tienda designada o al centro de servicio designado, o lleve a cabo el mantenimiento de acuerdo con el manual de servicio posventa de Blueshark. <br/>\
      Durante el mantenimiento regular, tenga cuidado y siga los siguientes consejos: <br/>\
      Antes de realizar un mantenimiento regular, elija un espacio abierto y plano, baje el caballete central del scooter y luego comience a mantener el scooter. <br/>\
      Después de un viaje de larga distancia, algunos componentes electrónicos del scooter pueden calentarse. No desmonte ninguna pieza inmediatamente para evitar daños. <br/>\
      Durante el mantenimiento regular, si se encuentra alguna anomalía en el scooter, realice los ajustes necesarios lo antes posible. Si usted no puede eliminar la anomalía, diríjase a la tienda designada o al centro de servicio designado para una inspección completa."
    }
  ],
  [
    {
      q: "No se puede encender el scooter",
      a:
        "Paso 1: <br/>\
      Compruebe si el interruptor de encendido está encendido, si no, encienda el interruptor de encendido del scooter; <br/>\
      Paso 2: <br/>\
      Compruebe si el Control Remoto se ha quedado sin batería. Compruebe si el indicador en la llave del control remoto está apagado o parpadeando; si está apagado, reemplace la batería;  <br/>\
      Paso 3: <br/>\
      Compruebe si la batería del scooter está instalada. de lo contrario, instale una batería con suficiente energía; si el nivel de batería está bajo, cárguela de acuerdo con las instrucciones. <br/>\
      Si aún no puede arrancar el scooter después de probar los métodos anteriores, comuníquese con la tienda o centro de servicio designado para su inspección y reparación."
    },

    {
      q: "¿Por qué la distancia del viaje se acorta después de la carga?",
      a:
        "Paso 1: <br/>\
      Compruebe si hay algún daño en los neumáticos o si es insuficiente la presión de los neumáticos. En caso afirmativo, reemplace el neumático o infle el neumático; <br/>\
      Paso 2: <br/>\
      Compruebe si la temperatura ambiente del scooter es demasiado baja. La baja temperatura del entorno de conducción afectará la eficiencia de descarga de la batería, que es un fenómeno normal. Asegúrese de que la temperatura del entorno de carga esté entre 5 ℃ y 55 ℃;  <br/>\
      Paso 3: <br/>\
      Compruebe si el tiempo de carga de la batería es demasiado corto. Asegúrese de que su método de carga sea correcto, y de que el enchufe de carga esté correctamente conectado; <br/>\
      * Después de varias cargas y descargas de la batería, la capacidad total de la batería puede degradar hasta cierto punto, lo cual es un fenómeno normal; <br/>\
      Si se han investigado las condiciones anteriores y el problema persiste, lleve el scooter a la tienda o el centro de servicio designado para su inspección y reparación."
    },

    {
      q: "El cargador genera calor durante la carga",
      a:
        "Generalmente, la temperatura del cargador aumentará durante el proceso de carga, que es un fenómeno normal. <br/>\
      Si el cargador se calienta demasiado y no se puede tocar con las manos, apague la alimentación inmediatamente para detener la carga y envíe el cargador a una tienda o centro de servicio designado para su inspección y reparación."
    },

    {
      q: "Códigos de error y consejos para la solución de problemas",
      a: troubles
    }
  ]
];



// WEBPACK FOOTER //
// ./src/assets/js/helpMultilngual/bs_es_questions.js